/* eslint-disable */
import React from 'react';
import { Container } from '@mui/material';
import { useOutletContext } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import SchoolIcon from '@mui/icons-material/School';

import PairedUsersMessaging from '../../components/pairedUsers/PairedUsersMessaging';

const Teachers = () => {
  const pairedUsers = useOutletContext();
  const isLoading = pairedUsers[5];
  const pairedList = pairedUsers[6]?.data?.data || [];

  return (
    <Container
      maxWidth="xl"
      sx={{
        p: '0 !important',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Helmet>
        <title>Edifying Teachers | Your Mentees</title>
      </Helmet>

      <PairedUsersMessaging
        pairedUsersList={pairedList}
        isLoading={isLoading}
        pageTitle="Your Mentees"
        emptyIcon={SchoolIcon}
        emptyTitle="No Teachers Paired Yet"
        emptyDescription="Once a teacher pairs with you, their profile will appear here for easy access."
        onlyPairedAndAdmin
      />
    </Container>
  );
};

export default Teachers;
